import { IconTextList } from '@vfde-brix/ws10/icon-text-list';
import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-sails/constants';
import { getTauschbonusAmount } from '@vfde-sails/page-options';
import { TAUSCHBONUS_ICON_TEXT_SUBLINE_ID } from '../../../app/constants';
import { startAppListening } from '../../../app/listener';
import { mountIconTextList } from '../../../components/IconTextList';
import getTauschbonusSubline from '../../../helpers/getTauschbonusSubline';
import { selectCustomerConfig } from '../slice';
import { RootState } from '../../../app/store';
import { setInitialState as setInitialTradeInState } from '../../tradeIn/slice';

/**
 * Mounts the promoOverview iconTextList
 */
export const mountPromoOverviewIconTextList = (
    containerId: string,
): IconTextList | null => {
    const iconTextList = mountIconTextList(containerId);

    /* istanbul ignore if */
    if (!iconTextList) {
        return null;
    }

    // update visibility (we want to show the whole iconTextList, if at least one promo is visible from CMS side)
    iconTextList.updateVisibility(true);

    listenForUpdates(iconTextList);

    return iconTextList;
};

const listenForUpdates = (iconTextList: IconTextList) => {
    startAppListening({
        actionCreator: setInitialTradeInState,
        effect: (_action, listenerApi) => {
            const state = listenerApi.getState();
            updatePromoOverviewIconTextList(iconTextList, state);
        },
    });

    startAppListening({
        predicate: (_action, currentState, previousState) => {
            const currentCustomerConfig = selectCustomerConfig(currentState);
            const previousCustomerConfig = selectCustomerConfig(previousState);

            return (
                currentCustomerConfig.isTradeIn !== previousCustomerConfig.isTradeIn
                || currentCustomerConfig.isTauschbonus !== previousCustomerConfig.isTauschbonus
                || currentCustomerConfig.isHardwareOnly !== previousCustomerConfig.isHardwareOnly
            );
        },
        effect: (_action, listenerApi) => {
            const state = listenerApi.getState();
            updatePromoOverviewIconTextList(iconTextList, state);
        },
    });
};

/**
 * Updates the promo-overview iconTextList.
 * This function checks based on the customerConfig
 * if the iconTextList for the applied promos should be shown or not
 */
export const updatePromoOverviewIconTextList = (
    iconTextList: IconTextList,
    state: RootState,
) => {
    const promoOverviewTauschbonusSublineElement = document.getElementById(TAUSCHBONUS_ICON_TEXT_SUBLINE_ID);
    const tauschbonusIconTextIndex = iconTextList
        .findItemIndex((_props, element) => element.contains(promoOverviewTauschbonusSublineElement));

    /* istanbul ignore if */
    if (!promoOverviewTauschbonusSublineElement || tauschbonusIconTextIndex === -1) {
        // could not find the iconTextList item with the tauschbonus subline span in it
        // so we cant toggle the element
        // this case may occure if the CMS editors forgot
        // to add the <span> or ID in the txtContent of the iconText
        return;
    }

    const customerConfig = selectCustomerConfig(state);

    if (customerConfig.isTradeIn && !customerConfig.isHardwareOnly) {
        iconTextList.toggleItem(tauschbonusIconTextIndex, true);

        let tauschbonusSublineText: string;

        if (customerConfig.isTauschbonus) {
            const tauschbonusOptions = window[ADDITIONAL_PAGE_OPTIONS].promos?.tauschbonus;
            const tauschbonusValue = getTauschbonusAmount(customerConfig.deviceId!);

            tauschbonusSublineText = (tauschbonusOptions && tauschbonusValue) ? getTauschbonusSubline(
                tauschbonusOptions.tauschbonusSublinePromoOverview,
                tauschbonusValue,
            ) : '';
        }
        else {
            tauschbonusSublineText = '';
        }

        promoOverviewTauschbonusSublineElement.innerHTML = `${tauschbonusSublineText ? ` ${tauschbonusSublineText}` : ''}`;
    }
    else {
        // if tradeIn is deactivated we have to hide the
        // iconTextList item completly
        iconTextList.toggleItem(tauschbonusIconTextIndex, false);
    }
};
